import Logo from '../../shared/images/logo.png'
import './style.css'

const Loader = () => {
  return (
    <div className="loader">
        <img src={Logo} alt="Laddar Dolcehem" />
    </div>
  )
}

export default Loader
